import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { CarpetAndUpholsteryCleaning } from '@modules/services/carpetAndUpholsteryCleaning/CarpetAndUpholsteryCleaning';
import { CONTACT } from '@common/constants';

const TITLE = 'Upholstery & Carpet Cleaning Service | Qeeper';
const DESC = `Expert upholstery & carpet cleaning service in London, here to rescue your carpets from stains and dust bunnies.  Book a cleaner now call ${CONTACT.PHONE}`;

const URL = 'https://www.qeeper.co.uk/services/carpet-and-upholstery-cleaning';
const SEO_KEYWORDS =
  'carpet cleaning service, carpet cleaner near me, rug cleaning, professional carpet cleaners near me';

const CarpetAndUpholsteryCleaningPage = () => {
  return (
    <>
      <Head>
        {/* PWA primary color */}
        <link
          href="https://fonts.googleapis.com/css2?family=Arimo:wght@400;700&family=Plus+Jakarta+Sans:wght@200;400;500;600;700;800&display=optional"
          rel="stylesheet"
        />
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <CarpetAndUpholsteryCleaning />
    </>
  );
};

export default CarpetAndUpholsteryCleaningPage;
